/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Typography,
  IconButton,
  Box,
  Stack
} from '@mui/material';
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

import Footer from "examples/Footer";



import { checkCustomers } from 'api/getApi';
import { useState, useEffect } from 'react';
import MLoading from "components/MLoading";
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
function Tables() {
  const [data, setData] = useState(null);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const [loading, setLoading] = useState(false);

  const columns = [
    { id: 'wallet', label: 'Wallet', width: '33.33%' },
    { id: 'children_count', label: 'Ref', width: '33.33%' },
    { id: 'points', label: 'Points', width: '33.33%' },
  ];

  const getDashboard = async (page) => {
    try {
      setLoading(true);
      const response = await checkCustomers(page);
      setData(response.data);
      setPagination({
        current_page: response.current_page,
        last_page: response.last_page,
      });
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDashboard(pagination.current_page);
  }, [pagination.current_page]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.last_page) {
      setPagination(prev => ({...prev, current_page: newPage}));
    }
  };

  if (loading || !data) return <MLoading />;

  return (
    <DashboardLayout>
   
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  List Users
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
    <TableContainer sx={{ width: '100%' }}>
    <Table sx={{ width: '100%' }}>
    <TableHead style={{width:"100%",display:"table-caption"}}>
      <TableRow sx={{
        display:"flex",
    width: '100%', 
    m: 0,          
    p: 0         
  }}>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  sx={{ 
                    width: column.width,
                    bgcolor: 'background.default',
                    borderBottom: '2px solid',
                    borderColor: 'divider'
                  }}
                >
                  <Typography variant="subtitle1" fontWeight={600}>
                    {column.label}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {data.length > 0 ? (
              data.map((row, index) => (
                <TableRow key={index}>
                  {columns.map((column) => (
                    <TableCell
                      key={`${column.id}-${index}`}
                      sx={{ borderBottom: '1px solid', borderColor: 'divider' }}
                    >
                      <Typography variant="body2">
                        {row[column.id] || '-'}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} sx={{ textAlign: 'center', py: 4 }}>
                  <Typography variant="body2" color="text.secondary">
                    No data available
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ p: 2 }}>
        <IconButton 
          onClick={() => handlePageChange(pagination.current_page - 1)}
          disabled={pagination.current_page === 1}
        >
          <ChevronLeft />
        </IconButton>

        <Typography variant="body1" sx={{ mx: 2, lineHeight: '40px' }}>
          Page {pagination.current_page} of {pagination.last_page}
        </Typography>

        <IconButton
          onClick={() => handlePageChange(pagination.current_page + 1)}
          disabled={pagination.current_page === pagination.last_page}
        >
          <ChevronRight />
        </IconButton>
      </Stack>
    </Box>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
